import React, { Suspense } from 'react';

import { useRouter } from 'next/compat/router';

import { User } from '@repo/domain/user';
import { withEventScope } from '@repo/event-processor';
import IconArrowRight from '@repo/ui-icons/IconArrowRight';
import { Button } from '@repo/ui-kit/components/core/Button';

import ProfileWithSearchParams from 'components/HeadMenu/ProfileWithSearchParams';
import HeaderProfileMenu from 'components/Layout/LoggedInUserLayout/Header/HeaderProfileMenu';
import { useEditorAndDashboardUpdateFeature } from 'global/growthbookUtils';
import { FlexRow } from 'styles/layouts';

interface HeaderUserActionsProps {
  user: User;
  onLogOut: () => void;
}

const HeaderUserActions: React.FC<HeaderUserActionsProps> = ({
  user,
  onLogOut,
}) => {
  const isNewDesignEnabled = useEditorAndDashboardUpdateFeature();
  const router = useRouter();

  const handleDashboardClick = () => {
    void router?.push('/');
  };

  return (
    <FlexRow alignItems="center" gap="var(--spacing-12)">
      <Suspense>
        {isNewDesignEnabled ? (
          <HeaderProfileMenu />
        ) : (
          <ProfileWithSearchParams user={user} onLogOut={onLogOut} />
        )}
      </Suspense>
      <Button
        dataTestId="header--back-to-dashboard"
        name="backToDashboardButton"
        rightIcon={IconArrowRight}
        onClick={handleDashboardClick}
      >
        <Button.Label>Back to Dashboard</Button.Label>
      </Button>
    </FlexRow>
  );
};

export default withEventScope(HeaderUserActions, {
  module: 'headerUserActions',
});
